import React from 'react';
import { useSelector } from 'react-redux';
import { isNodeMyContent } from '../../utils/Utils';
import './styles.scss';
export const Footer = () => {
 const { navData } = useSelector(state => state?.cvNavData);
  const nodoNav = navData?.selected;
  const recordingBar = useSelector(state => state?.recordingsBar);
  return (
    <footer
      className={`${
        isNodeMyContent(nodoNav?.code) && recordingBar?.show
          ? 'new-footer-my-content'
          : 'new-footer'
      }`}
    />
  );
};
